import { depositBaseHref } from '../constants/deposits';
import { DepositsTopPeriods } from '../interfaces/deposits';

export const generateDepositHref = (depositPeriod?: DepositsTopPeriods) => {
  const params = new URLSearchParams({ sortProperty: 'rate' });

  let period: string;
  switch (depositPeriod) {
    case DepositsTopPeriods.THREE_MONTHS:
      period = '91';
      break;
    case DepositsTopPeriods.SIX_MONTHS:
      period = '183';
      break;
    case DepositsTopPeriods.TWELVE_MONTH:
      period = '365';
      break;
    case DepositsTopPeriods.THREE_YEARS:
      period = '1081';
      break;
  }

  period && params.append('term', period);
  const paramsString = params.toString();

  return `${depositBaseHref}?${paramsString}`;
};
